/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { greenApiWebhookInteractiveButtonsResponseSchema } from "./greenApiWebhookInteractiveButtonsResponseSchema.ts";
import { greenApiWebhookTextMessageDataSchema } from "./greenApiWebhookTextMessageDataSchema.ts";
import { typeMessageEnumSchema } from "./typeMessageEnumSchema.ts";

export const greenApiWebhookMessageDataSchema = z.object({
	typeMessage: typeMessageEnumSchema.describe("* `interactiveButtonsResponse` - Interactive Buttons Response\n* `textMessage` - Text Message"),
	interactiveButtonsResponse: greenApiWebhookInteractiveButtonsResponseSchema.nullish(),
	textMessageData: greenApiWebhookTextMessageDataSchema.nullish(),
});
